module.exports = __webpack_public_path__ + "img/camera-security.fd7dbb82.svg";